// src/views/admin/caisse/ADCaisseShared.jsx
import { useState } from "react";
import { useToastHook } from "../../../utils/useToast";

/* ============================================================================
 * Modal générique — utilisé par toutes les sous-pages du module Caisse.
 * ========================================================================== */
export function Modal({ title, onClose, children, width }) {
  return (
    <div className="modal-overlay" onClick={e => e.target === e.currentTarget && onClose()}>
      <div className="modal-box" style={width ? { width } : undefined}>
        <div className="modal-title">
          {title}
          <button className="ibtn" style={{ border: "none" }} onClick={onClose}>
            <i className="ti ti-x" />
          </button>
        </div>
        {children}
      </div>
    </div>
  );
}

/* ============================================================================
 * AnnulationModal — saisie du motif d'annulation d'un versement.
 * Utilisé dans ADCaisseSituationVersements.jsx.
 * ========================================================================== */
export function AnnulationModal({ onClose, onConfirm, saving }) {
  const [motif, setMotif] = useState("");
  const toast = useToastHook();

  const handleConfirm = () => {
    if (!motif.trim()) { toast.error("Le motif d'annulation est requis"); return; }
    onConfirm(motif);
  };

  return (
    <Modal title="Annuler le versement" onClose={onClose}>
      <div className="fg">
        <label>Motif d'annulation *</label>
        <textarea value={motif} onChange={e => setMotif(e.target.value)} placeholder="Ex: Erreur de saisie, doublon..." />
      </div>
      <div className="factions">
        <button className="bsec" onClick={onClose} disabled={saving}>Annuler</button>
        <button className="bprim rd" onClick={handleConfirm} disabled={saving}>
          {saving ? "..." : <><i className="ti ti-check" /> Confirmer l'annulation</>}
        </button>
      </div>
    </Modal>
  );
}

/* Sous-onglets génériques — même style visuel que celui de ADCaisse.jsx,
 * ré-exporté ici pour que chaque sous-page puisse afficher ses propres
 * sous-sous-onglets sans dupliquer le CSS. */
export function SubTabNav({ items, active, onChange, style }) {
  return (
    <div className="sub-tab-nav" style={style}>
      {items.map(o => (
        <button
          key={o.key}
          className={`sub-tab-btn ${active === o.key ? "active" : ""}`}
          onClick={() => onChange(o.key)}
        >
          <i className={`ti ${o.icon}`} /> {o.label}
        </button>
      ))}
    </div>
  );
}